import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    id_user: localStorage.getItem('id_user'),
    isLoggedIn: localStorage.getItem('isLoggedIn'),
    isPro: localStorage.getItem('isPro'),
    favorites:[]
  },
  getters: {},
  mutations: {
    SET_LOGGED_IN(state, value) {
      state.isLoggedIn = value
      localStorage.setItem('isLoggedIn', value)
    },
    SET_UNLOCK_APP(state, value) {
      state.isPro = value
      localStorage.setItem('isPro', value)
    },
    SET_ID_USER(state, value) {
      state.id_user = value;
      localStorage.setItem('id_user', value)
    },
    SET_FAVORITES(state, value) {
      state.favorites = value;
    }
  },
  actions: {
    setLoggedIn({ commit }, value) {
      commit('SET_LOGGED_IN', value)
    },
    unlockApp({ commit }, value) {
      commit('SET_UNLOCK_APP', value)
    },
    setIdUser({commit }, value) {
      commit('SET_ID_USER', value);
    },
    setFavorites({commit }, value) {
      commit('SET_FAVORITES', value);
    }
  },
  modules: {},
})
